/*
 * @Author: 吴俊杰_20717 20717@etransfar.com
 * @Date: 2022-12-25 14:00:54
 * @LastEditors: 吴俊杰_20717 20717@etransfar.com
 * @LastEditTime: 2022-12-26 15:25:18
 * @FilePath: /lytMobile/src/routes/personalInfo/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { Toast,List } from "antd-mobile";
import styles from './index.less';
export default class contractManage extends Component {
  state = {
    
  }

  componentDidMount() {

  }


  render() {
    return (
      <div className={styles.certification}>
            <div className="list"><div className="label">法人身份认证</div><div className="info pending">审核中</div></div>
            <div className="list"><div className="label">营业执照认证</div><div className="info error">认证失败</div></div>
            <div className="list"><div className="label">道路运输经营许可证</div><div className="info success">已认证</div></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/certification/index.js